import { render, staticRenderFns } from "./FormImageFileField.vue?vue&type=template&id=84dfa6e2&scoped=true&"
import script from "./FormImageFileField.vue?vue&type=script&lang=js&"
export * from "./FormImageFileField.vue?vue&type=script&lang=js&"
import style0 from "./FormImageFileField.vue?vue&type=style&index=0&id=84dfa6e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dfa6e2",
  null
  
)

export default component.exports